/* @flow */
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import createDebugger from 'debug';
import { fromJS } from 'immutable';
import { prop, path } from 'ramda';

import { fromJson, type TemplateObject } from './types';

const debug = createDebugger('app:modules:templates:epics'); // eslint-disable-line no-unused-vars

import { ENCLAVE_TEMPLATES_ENDPOINT } from './types.js';
import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  DELETE,
  DELETE_SUCCESS,
  DELETE_FAILURE,
} from './action-types.js';

import {
  SAVE_TEMPLATE_ICON,
} from 'modules/icons/action-types.js';
import {saveEnclaveTemplateIcon} from './actions';

export const listToOrderedMap = (list: $TODO) => {
  return fromJS(list)
    .toOrderedMap()
    .mapKeys((k, v) => v.get('id'));
};

const fetchEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH)
    .mergeMap(() =>
      ajax.get(ENCLAVE_TEMPLATES_ENDPOINT)
        .map(prop('response'))
        .map(listToOrderedMap)
        .map(templates => ({
          type: FETCH_SUCCESS,
          payload: templates,
        }))
        .catch(err => Observable.of({
          type: FETCH_FAILURE,
          error: true,
          payload: err,
        })));

const saveTemplateEpic = (action$, store, { ajax }) =>
  action$.ofType(SAVE)
    .mergeMap(({ payload }: { payload: TemplateObject }) => {
      return ajax.postJSON(`${ENCLAVE_TEMPLATES_ENDPOINT}`, payload)
        .map(prop('response'))
        .mergeMap(payload => {
          return Observable.of({
            type: SAVE_SUCCESS,
            payload: fromJson(payload),
            meta: {
              alert: { type: 'success', text: `Template saved successfully.` },
            },
          });
        })
        .catch(err => {
          return Observable.of({
            type: SAVE_FAILURE,
            meta: {
              error: true,
              payload: err,
              alert: { type: 'error', text: `Template could not be saved. ${path(['xhr', 'response', 'message'], err)}` },
            },
          });
        });
    });

const deleteTemplateEpic = (action$, store, { ajax }) =>
  action$.ofType(DELETE)
    .mergeMap(({ payload: id }) => {
      return ajax.delete(`${ENCLAVE_TEMPLATES_ENDPOINT}/${id}`)
        .mergeMap(({ response }) => {
          return Observable.of({
            type: DELETE_SUCCESS,
            payload: id,
            meta: {
              alert: { type: 'success', text: 'Template deleted. Companies and users will no longer have access to it.' },
            },
          });
        })
        .catch(err => {
          return Observable.of({
            type: DELETE_FAILURE,
            meta: {
              alert: { type: 'error', text: 'Template could not be deleted. Please reload this page and try again' },
            },
          });
        });
    });

const saveTemplateIconEpic = (action$, store, { ajax }) =>
  // first, consume a SAVE event, meaning an enclave is being saved
  action$.ofType(SAVE)
    .switchMap(({ meta }) =>
      // wait until a the enclave is saved successfully
      action$.ofType(SAVE_SUCCESS)
        .take(1)
        .mergeMap(({ payload }) => {

          // dispatch a SAVE_ENCLAVE_ICON event, combining the enclave GUID
          // from the SAVE_SUCCESS event and the file from the SAVE event
          // Note --  SVG and regular icons updated in seperate calls
          const filesToSave = [];
          if (meta.file) filesToSave.push(meta.file);
          if (meta.sourceSVGFile) filesToSave.push(meta.sourceSVGFile);

            return filesToSave.length > 0
              ? filesToSave.map(iconFile => saveEnclaveTemplateIcon(payload.id, iconFile))
              : Observable.empty()
          }
        )
        // break the flow if the enclave fails to save
        .takeUntil(action$.ofType(SAVE_FAILURE))
    );



export default combineEpics(
  fetchEpic,
  saveTemplateEpic,
  deleteTemplateEpic,
  saveTemplateIconEpic,
);




// WEBPACK FOOTER //
// ./src/app/modules/templates/epics.js